export default "__VITE_PUBLIC_ASSET__3f6c0370__"